import { render, staticRenderFns } from "./folderInfo.vue?vue&type=template&id=d83fed7a&scoped=true&"
import script from "./folderInfo.vue?vue&type=script&lang=js&"
export * from "./folderInfo.vue?vue&type=script&lang=js&"
import style0 from "./folderInfo.vue?vue&type=style&index=0&id=d83fed7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83fed7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VIcon,VSheet,VSpacer})
